<script>
	import Navbar from './CustomNavBar.svelte';
	import CustomFooter from './CustomFooter.svelte';
	import WelcomePage from './sections/WelcomePage.svelte'
	import About from './sections/About.svelte'
	import Contact from './sections/Contact.svelte';
    import WordossPage from './sections/Wordoss_page.svelte';
    import LanguageLiftPage from './sections/language_lift_page.svelte';
    import LanguageLensPage from './sections/language_lens_page.svelte';

	
</script>

<main>
	<!-- Navigation Bar -->
	<Navbar />

	<!-- Top Section / Welcome Page-->
	<WelcomePage />

	<!-- Wordoss -->
	<WordossPage />

	<!-- LanguageLift -->
	<!--<LanguageLiftPage />-->

	<!-- LanguageLens -->
  <!--<LanguageLensPage/>-->

	<!-- About me -->
	<About />

	<!-- Contact -->
	<Contact />

	<!-- Footer -->
	<CustomFooter />

</main>

<style>
	
	
</style>